import useVariablePattern from './useVariablePattern';

export default function useClassName(className) {
  return useVariablePattern(className);
}
